(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inquiry-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-inquiry-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var blockId = btn.getAttribute('data-inquiry-open');
        var overlay = document.getElementById('inquiry-modal-overlay-' + blockId);
        if (!overlay) return;

        if (overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        var messageField = overlay.querySelector('.inquiry-message');
        var productField = overlay.querySelector('input[name="contact[Product]"]');
        var productDisplayField = overlay.querySelector('.inquiry-readonly-product');
        var skuField = overlay.querySelector('input[name="contact[SKU]"]');

        // Keep a pristine copy of the product name (without ring size) so
        // re-opening the modal doesn't stack "Ring Size:" text repeatedly.
        if (!productField.dataset.baseName) {
          productField.dataset.baseName = productField.value;
        }

        function appendRingSize(baseName) {
          var ringSizeSelect = document.querySelector('select[name="properties[Ring Size]"]');
          var ringSize = ringSizeSelect ? ringSizeSelect.value : '';
          return ringSize ? (baseName + ' - Ring Size: ' + ringSize) : baseName;
        }

        function fillMessage() {
          if (!messageField) return;

          var msg = 'Enquiry for product: ' + productField.value;
          if (skuField && skuField.value) {
            msg += ' (SKU: ' + skuField.value + ')';
          }
          var hintText = 'add more information';
          messageField.value = msg + '\n' + hintText;
          messageField.dataset.autoMsg = msg;
          messageField.dataset.hintText = hintText;

          // Remove any previously bound listener from a prior open, so it
          // doesn't stack up, then bind a fresh one for this open.
          if (messageField._hintClearHandler) {
            messageField.removeEventListener('focus', messageField._hintClearHandler);
          }
          messageField._hintClearHandler = function clearHint() {
            var autoMsg = messageField.dataset.autoMsg;
            var hint = messageField.dataset.hintText;
            if (autoMsg && hint && messageField.value === autoMsg + '\n' + hint) {
              messageField.value = autoMsg + '\n';
            }
            messageField.removeEventListener('focus', messageField._hintClearHandler);
            messageField._hintClearHandler = null;
          };
          messageField.addEventListener('focus', messageField._hintClearHandler);
        }

        var handle = btn.getAttribute('data-product-handle');
        var variantId = new URLSearchParams(window.location.search).get('variant');

        if (handle && variantId && skuField) {
          fetch('/products/' + handle + '.js')
            .then(function (res) { return res.json(); })
            .then(function (product) {
              var variant = (product.variants || []).find(function (v) {
                return String(v.id) === String(variantId);
              });
              if (variant) {
                if (variant.sku) {
                  skuField.value = variant.sku;
                }
                productField.dataset.baseName = product.title + (variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : '');
              }
            })
            .catch(function () {
              // Silently fall back to the server-rendered Product/SKU on any error.
            })
            .then(function () {
              var finalName = appendRingSize(productField.dataset.baseName);
              productField.value = finalName;
              if (productDisplayField) {
                productDisplayField.value = finalName;
              }
              fillMessage();
            });
        } else {
          var finalName = appendRingSize(productField.dataset.baseName);
          productField.value = finalName;
          if (productDisplayField) {
            productDisplayField.value = finalName;
          }
          fillMessage();
        }
      });
    });

    document.querySelectorAll('[data-inquiry-overlay]').forEach(function (overlay) {
      overlay.querySelector('[data-inquiry-close]').addEventListener('click', function () {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          overlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
